import { Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";
import { useFormatPrice } from "hooks";

const Footer = ({ value }) => {
  const formatPrice = useFormatPrice();
  return value && value.id ? (
    <>
      <Grid item xs={12} md={6}>
        {value.note && (
          <div className="grid gap-[10px]">
            <span className="text-[12px] font-medium text-gray-500">
              Note:{" "}
            </span>
            <span>{value.note}</span>
          </div>
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        <Table size="small">
          <TableBody>
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>
                <div className="grid gap-1 text-[16px] font-medium text-gray-500">
                  <span>Subtotal</span>
                  <span>Total tax ({value.taxRate}%)</span>
                  <span>Discount on total</span>
                </div>
              </TableCell>
              <TableCell align="right">
                <div className="grid gap-1 text-[16px] font-bold text-gray-500">
                  <span>{formatPrice(value.subtotal)}</span>
                  <span>(+) {formatPrice(value.taxAmt)}</span>
                  <span>(-) {formatPrice(value.disAmt)}</span>
                </div>
              </TableCell>
            </TableRow>
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>
                <span className="text-[18px] font-semibold text-gray-500 uppercase tracking-wider">
                  Quote Total
                </span>
              </TableCell>
              <TableCell align="right">
                <span className="text-[18px] font-semibold text-gray-500 uppercase tracking-wider">
                  {formatPrice(value.totalPay)}
                </span>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </>
  ) : (
    "null"
  );
};

export default Footer;
